import { Grid } from "@mui/material";
import React from "react";
import JSafeHeader from "./home/header";
import JSafeTable from "./home/table";

const JSafe = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <JSafeHeader />
      </Grid>
      <Grid item xs={12}>
        <JSafeTable />
      </Grid>
    </Grid>
  );
};

export default JSafe;
